
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Bike } from "@/types/models";
import { UseFormReturn } from "react-hook-form";
import { Separator } from "@/components/ui/separator";
import { RentalFormValues } from "@/hooks/useRentalForm";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";

interface BikeSelectionFormProps {
  form: UseFormReturn<RentalFormValues>;
  bikes: Bike[];
  selectedBikes: Bike[];
  handleBikesChange: (bikeIds: string[]) => void;
}

const BikeSelectionForm = ({ form, bikes, selectedBikes, handleBikesChange }: BikeSelectionFormProps) => {
  const handleBikeToggle = (bikeId: string, checked: boolean) => {
    const currentBikeIds = form.getValues("bikeIds");
    let newBikeIds: string[];
    
    if (checked) {
      newBikeIds = [...currentBikeIds, bikeId];
    } else {
      newBikeIds = currentBikeIds.filter(id => id !== bikeId);
    }
    
    handleBikesChange(newBikeIds);
  };

  return (
    <div className="space-y-3">
      <div className="border-b pb-3">
        <h2 className="text-lg font-semibold">Seleccionar Bicicleta(s)</h2>
        <p className="text-sm text-gray-600">Marque las bicicletas que el cliente desea alquilar.</p>
      </div>
      
      <FormField
        control={form.control}
        name="bikeIds"
        render={() => (
          <FormItem>
            <Card className="p-4">
              <ScrollArea className="h-80">
                <div className="space-y-3 pr-4">
                  {bikes.map(bike => (
                    <div key={bike.id} className="flex items-center space-x-3">
                      <Checkbox
                        checked={form.getValues("bikeIds").includes(bike.id)}
                        onCheckedChange={(checked) => handleBikeToggle(bike.id, !!checked)}
                      />
                      <span className="text-sm">
                        #{bike.number} {bike.type} {bike.size > 0 ? "R"+bike.size : ""}
                      </span>
                    </div>
                  ))}
                </div>
              </ScrollArea>
            </Card>
            <FormMessage />
          </FormItem>
        )}
      />
      
      {selectedBikes.length > 0 && (
        <Card className="bg-blue-50 border-blue-200">
          <CardContent className="p-4">
            <h3 className="font-medium mb-2">Bicicletas seleccionadas ({selectedBikes.length})</h3>
            <div className="flex flex-wrap gap-2">
              {selectedBikes.map(bike => (
                <Badge key={bike.id} variant="secondary">
                  #{bike.number} - {bike.model} {bike.size > 0 ? "R"+bike.size : ""}
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
      
      <Separator />
    </div>
  );
};

export default BikeSelectionForm;
